<template>
  <v-container v-if="album">
    <page-header :title="album.title" :info="album.band" />
    <v-container grid-list-md :class="['pa-0']">
      <v-layout row wrap>
        <v-flex d-flex lg6 xs12>
          <v-card>
            <div hidden v-html="`${album.band} - ${album.title}`" :class="['meta-description']" />
            <v-img v-if="album.cover && !album.cover.includes('undefined')" :src="album.cover" :alt="album.cover" :title="album.title" />
            <v-card-text>
              <v-container :class="['pa-0', 'my-2']">
                <template v-for="(sides, index) in album.tracks">
                  <h3 v-if="album.tracks.length > 1" v-html="lang.volume(index)" :class="['title', 'font-weight-light']" :key="index + '-heading'" />
                  <v-list dense :class="['mt-2']" :key="index">
                    <template v-for="(track, i) in sides">
                      <v-list-tile :key="i" :title="track">
                        <v-list-tile-action>
                          <v-icon>mdi-music-note</v-icon>
                        </v-list-tile-action>
                        <v-list-tile-content>
                          <v-list-tile-title v-html="track" :class="['wrap']" />
                        </v-list-tile-content>
                      </v-list-tile>
                      <v-divider inset :key="i + '-divider'" v-if="i < sides.length - 1" />
                    </template>
                  </v-list>
                </template>
                <h3 v-if="album.date || album.medium || album.label || album.catalogNumber" :class="['title', 'font-weight-light', 'mt-3']" v-html="lang.albumDetailsHeading" />
                <v-list dense two-line :class="['my-2']">
                  <template v-if="album.label">
                    <v-list-tile ripple :to="`/labels/${album.label}`" :title="lang.viewMoreInfo(album.label)">
                      <v-list-tile-action>
                        <v-icon>mdi-volume-medium</v-icon>
                      </v-list-tile-action>
                      <v-list-tile-content>
                        <v-list-tile-title v-html="lang.label" />
                        <v-list-tile-sub-title v-html="album.label" />
                      </v-list-tile-content>
                    </v-list-tile>
                    <v-divider inset />
                  </template>
                  <template v-if="album.date">
                    <v-list-tile>
                      <v-list-tile-action>
                        <v-icon>mdi-calendar</v-icon>
                      </v-list-tile-action>
                      <v-list-tile-content>
                        <v-list-tile-title v-html="lang.releaseDate" />
                        <v-list-tile-sub-title v-html="simpleDateFormat(album.date)" />
                      </v-list-tile-content>
                    </v-list-tile>
                    <v-divider inset />
                  </template>
                  <template v-if="album.medium">
                    <v-list-tile>
                      <v-list-tile-action>
                        <v-icon>mdi-disk</v-icon>
                      </v-list-tile-action>
                      <v-list-tile-content>
                        <v-list-tile-title v-html="lang.medium" />
                        <v-list-tile-sub-title v-html="album.medium" />
                      </v-list-tile-content>
                    </v-list-tile>
                    <v-divider inset />
                  </template>
                  <template v-if="album.catalogNumber">
                    <v-list-tile>
                      <v-list-tile-action>
                        <v-icon>mdi-format-list-numbers</v-icon>
                      </v-list-tile-action>
                      <v-list-tile-content>
                        <v-list-tile-title v-html="lang.catalogNumber" />
                        <v-list-tile-sub-title v-html="album.catalogNumber" />
                      </v-list-tile-content>
                    </v-list-tile>
                    <v-divider inset />
                  </template>
                </v-list>
              </v-container>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex d-flex lg6 xs12>
          <v-card>
            <v-card-text>
              <v-container :class="['pa-0', 'mt-2']">
                <h3 :class="['title', 'font-weight-light', 'mt-3']" v-html="lang.personnel" />
                <v-list two-line v-for="(person, index) in album.personnel" dense :class="['mt-2']" :key="index">
                  <template>
                    <v-list-tile ripple :key="index" :title="lang.viewMoreInfo(person.name)" :to="`/artists/${person.id}`">
                      <v-list-tile-action>
                        <v-icon>mdi-account</v-icon>
                      </v-list-tile-action>
                      <v-list-tile-content>
                        <v-list-tile-title v-html="person.name" />
                        <v-list-tile-sub-title v-html="person.instrument" />
                      </v-list-tile-content>
                      <chevron-right />
                    </v-list-tile>
                    <v-divider inset :key="index + '-divider'" v-if="index < album.personnel.length - 1" />
                  </template>
                </v-list>
                <warning :message="lang.recordsNotFound(lang.personnel)" v-if="!album.personnel.length" />
              </v-container>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </v-container>
</template>
<script>
import lang from '../helpers/lang'
import methods from '../helpers/methods'

export default {
  name: 'albums-id',
  mixins: [
    methods
  ],
  data () {
    return {
      lang,
      id: null,
      album: null
    }
  },
  watch: {
    /**
     * route.params.id watcher
     */
    '$route.params.id' () {
      this.onMounted()
    }
  },
  mounted () {
    this.onMounted()
  },
  methods: {
    /**
     * Mounted event handler
     * @method onMounted
     * @return {void}
     */
    onMounted () {
      this.id = this.$route.params.id
      const cache = this.getCachedPage('albums', this.id)
      cache ? this.done(cache) : this.getAlbumData()
    },
    /**
     * Get the album data from the API
     * @method getAlbumData
     * @return {void}
     */
    getAlbumData () {
      const url = this.$root.routes.find(route => route.url.includes('albums/:')).url.replace(':id', this.id)
      this.$http(url)
        .then(response => {
          this.done(response.data.payload)
        })
    },
    /**
     * Process the data from API or from the cache
     * @method done
     * @param {object} response [response=null]
     * @return {void}
     */
    done (response = null) {
      this.album = response
      this.$nextTick(() => {
        this.emitRouteChange()
        this.$nextTick(() => {
          this.setLastBreadcrumbsItemText(this.album.title)
        })
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/albums-id.vue